<script setup lang="ts">
import { computed, PropType } from "vue";

export type CardPadding = "none" | "sm" | "md" | "lg";
export type CardElevation = "flat" | "sm" | "md" | "lg" | "xl";
export type CardRadius = "md" | "xl";

const props = defineProps({
  padding: {
    type: String as PropType<CardPadding>,
    default: "none",
  },
  elevation: {
    type: String as PropType<CardElevation>,
    default: "flat",
  },
  border: {
    type: Boolean,
    default: true,
  },
  radius: {
    type: String as PropType<CardRadius>,
    default: "md",
  },
  chart: {
    type: Boolean,
    default: false,
  },
});

const paddingClasses: Record<CardPadding, string> = {
  none: "",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
};

const radiusClasses: Record<CardRadius, string> = {
  md: "rounded-md",
  xl: "rounded-xl",
};

const elevationClasses: Record<CardElevation, string> = {
  flat: "",
  sm: "shadow-sm",
  md: "shadow",
  lg: "shadow-md",
  xl: "shadow-lg",
};

const cardClasses = computed(() => [
  "relative bg-white",
  props.chart ? "chart-card" : radiusClasses[props.radius],
  paddingClasses[props.padding],
  !props.chart && elevationClasses[props.elevation],
  !props.chart && props.border && "border border-gray-200",
]);
</script>

<template>
  <div :class="cardClasses">
    <slot />
  </div>
</template>
